import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from './services/auth.service';
import { MainPageComponent } from './components/core/main-page/main-page.component';
import { SiteComponent } from './components/site/site.component';
import { UserManagerComponent } from './components/site-child/user-manager/user-manager.component';
import { SiteDetailComponent } from './components/site-child/site-detail/site-detail.component';
import { ServiceDetailComponent } from './components/site-child/service-detail/service-detail.component';
import { LoginComponent } from './components/login/login.component';

import { AppURL } from './app.url';
import { PolicyComponent } from './components/mobile-info/policy/policy.component';
import { TermsComponent } from './components/mobile-info/terms/terms.component';
import { AboutusComponent } from './components/mobile-info/aboutus/aboutus.component';

const routes: Routes = [
  {
    path: AppURL.MainPage,
    component: MainPageComponent,
    canActivate: [AuthService],
    children: [
      {
        path: AppURL.Site + '/:siteId',
        component: SiteComponent,
        children: [
          {
            path: AppURL.HospitalDetail,
            component: SiteDetailComponent,
          },
          {
            path: AppURL.ServiceDetail + '/:serviceId',
            component: ServiceDetailComponent,
          },
          {
            path: AppURL.UserDetail + '/:adminId',
            component: UserManagerComponent,
          }
        ]
      }
    ]
  },
  {
    path: AppURL.Login,
    component: LoginComponent
  },
  {
    path: AppURL.Policy,
    component: PolicyComponent
  },
  {
    path: AppURL.Terms,
    component: TermsComponent
  },
  {
    path: AppURL.About,
    component: AboutusComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AuthService
  ]
})
export class AppRoutingModule { }
